(function () {
  if (window.SellyPrice && window.SellyPrice.__initialized) return;

  const moneyFormat =
    (window.theme && theme.moneyFormat) ||
    (window.Shopify && Shopify.money_format) ||
    '${{amount}}';
  const currencyCode =
    (window.Shopify && Shopify.currency && Shopify.currency.active) || '';

  let rawSaleOffers = [];
  let rawBundleOffers = [];

  function formatMoney(amountDollars) {
    const cents = Math.round(Number(amountDollars) * 100);
    let amountHtml = '';
    if (window.themeVendor && themeVendor.themeCurrency && themeVendor.themeCurrency.formatMoney) {
      amountHtml = themeVendor.themeCurrency.formatMoney(cents, moneyFormat);
    } else if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      amountHtml = Shopify.formatMoney(cents, moneyFormat);
    } else {
      amountHtml = '$' + Number(amountDollars).toFixed(2);
    }
    if (!currencyCode || currencyCode === 'USD') return amountHtml;
    return amountHtml + '<span class="b24-currency-code">' + currencyCode + '</span>';
  }

  function normalizeOfferBag(bag) {
    if (!bag || typeof bag !== 'object') return [];
    if (Array.isArray(bag)) return bag;
    return Object.keys(bag).map(function (key) {
      return bag[key];
    });
  }

  function normalizeRawOffers(data) {
    const offers = (data && data.offers) || {};
    rawSaleOffers = normalizeOfferBag(offers['1'] || offers[1]);
    const bundles = [];
    Object.keys(offers).forEach(function (key) {
      if (String(key) === '1') return;
      normalizeOfferBag(offers[key]).forEach(function (offer) {
        if (offer) bundles.push(offer);
      });
    });
    if (bundles.length) rawBundleOffers = bundles;
    return rawSaleOffers;
  }

  function getGroupIds(group) {
    if (!group || typeof group !== 'object') return [];
    const collected = [];
    function pushIds(list) {
      if (!Array.isArray(list)) return;
      list.forEach(function (item) {
        if (item == null) return;
        if (typeof item === 'object') {
          const id = item.id || item.product_id || item.variant_id;
          if (id != null) collected.push(id);
          return;
        }
        collected.push(item);
      });
    }
    pushIds(group.ids);
    pushIds(group.product_ids);
    pushIds(group.variant_ids);
    pushIds(group.products);
    pushIds(group.variants);
    return collected;
  }

  function idsMatch(candidate, targets) {
    const id = Number(candidate);
    if (!Number.isFinite(id)) return false;
    for (let i = 0; i < targets.length; i++) {
      if (Number(targets[i]) === id) return true;
    }
    return false;
  }

  function productInOfferGroups(offer, productIdOrIds) {
    const targets = Array.isArray(productIdOrIds) ? productIdOrIds : [productIdOrIds];
    const groups = offer.product_groups || [];
    for (let i = 0; i < groups.length; i++) {
      const ids = getGroupIds(groups[i]);
      for (let j = 0; j < ids.length; j++) {
        if (idsMatch(ids[j], targets)) return true;
      }
    }
    return false;
  }

  function calcPriceFromDiscount(catalogPrice, discount) {
    if (!discount) return catalogPrice;
    const typeId = Number(discount.type_id);
    const value = Number(discount.value);
    if (!Number.isFinite(value) || !typeId) return catalogPrice;
    if (typeId === 1) return (catalogPrice * (100 - value)) / 100;
    if (typeId === 2) return Math.max(0, catalogPrice - value);
    if (typeId === 7) return Math.min(catalogPrice, value);
    return catalogPrice;
  }

  function calcPriceFromOffer(catalogPrice, offer) {
    return calcPriceFromDiscount(catalogPrice, (offer && offer.discount) || {});
  }

  function getDiscountForProduct(offer, productIdOrIds) {
    const targets = Array.isArray(productIdOrIds) ? productIdOrIds : [productIdOrIds];
    const groups = offer.product_groups || [];
    let groupIndex = -1;

    for (let i = 0; i < groups.length; i++) {
      const group = groups[i] || {};
      const ids = getGroupIds(group);
      for (let j = 0; j < ids.length; j++) {
        if (idsMatch(ids[j], targets)) {
          groupIndex = i;
          // Explicit per-group discount object wins when present.
          const groupDiscount = group.discount;
          if (groupDiscount && Number(groupDiscount.type_id) > 0) return groupDiscount;
          break;
        }
      }
      if (groupIndex >= 0) break;
    }

    if (groupIndex < 0) return null;

    const offerDiscount = offer && offer.discount;
    if (!offerDiscount) return null;

    // type_id 9: Selly "list" discounts — ls[i] maps to product_groups[i]
    // (e.g. 4040: group0 No discount, group1 20%).
    if (Number(offerDiscount.type_id) === 9 && Array.isArray(offerDiscount.ls)) {
      const entry = offerDiscount.ls[groupIndex];
      if (!entry || Number(entry.type_id) <= 0) return null;
      return entry;
    }

    // Offer-level % / amount applies to every group that has no own discount
    // (e.g. Kortek FBT: one 20% on the whole bundle).
    if (Number(offerDiscount.type_id) > 0 && Number(offerDiscount.type_id) !== 9) {
      return offerDiscount;
    }

    return null;
  }

  function getOfferProductIds(offer) {
    const result = [];
    const groups = offer.product_groups || [];
    for (let i = 0; i < groups.length; i++) {
      const ids = getGroupIds(groups[i]);
      for (let j = 0; j < ids.length; j++) {
        const id = Number(ids[j]);
        if (Number.isFinite(id) && result.indexOf(id) === -1) result.push(id);
      }
    }
    return result;
  }

  function collectOffersByType(typeConstName, fallbackType) {
    const collected = [];
    if (!(window.sl9 && sl9.manager && sl9.manager.offer)) return collected;

    const typeId =
      (sl9.struct && sl9.struct.consta && sl9.struct.consta[typeConstName]) || fallbackType;
    const fromAll =
      (typeof sl9.manager.offer.ListAll === 'function' && sl9.manager.offer.ListAll(typeId)) ||
      (typeof sl9.manager.offer.List === 'function' && sl9.manager.offer.List(typeId)) ||
      (sl9.manager.offer.Data && sl9.manager.offer.Data[typeId]) ||
      [];

    (Array.isArray(fromAll) ? fromAll : normalizeOfferBag(fromAll)).forEach(function (offer) {
      if (offer) collected.push(offer);
    });
    return collected;
  }

  function collectSaleOffers() {
    if (rawSaleOffers.length) return rawSaleOffers;
    return collectOffersByType('OfferTypeFirst', 1);
  }

  function collectBundleOffers() {
    if (rawBundleOffers.length) return rawBundleOffers;

    const names = [
      'OfferTypeBundle',
      'OfferTypeCombo',
      'OfferTypeFbt',
      'OfferTypeSecond',
      'OfferTypeThird',
    ];
    const collected = [];
    names.forEach(function (name, index) {
      collectOffersByType(name, index + 2).forEach(function (offer) {
        collected.push(offer);
      });
    });

    // Always also scan raw Data bags (typed lists are often incomplete on listing pages).
    if (window.sl9 && sl9.manager && sl9.manager.offer && sl9.manager.offer.Data) {
      Object.keys(sl9.manager.offer.Data).forEach(function (key) {
        if (String(key) === '1') return;
        normalizeOfferBag(sl9.manager.offer.Data[key]).forEach(function (offer) {
          if (offer) collected.push(offer);
        });
      });
    }

    return collected;
  }

  function collectAllOffers() {
    const seen = new Set();
    const merged = [];
    collectSaleOffers()
      .concat(collectBundleOffers())
      .forEach(function (offer) {
        if (!offer) return;
        const key = String(
          offer.id ||
            offer.offer_id ||
            JSON.stringify(getOfferProductIds(offer)) + JSON.stringify(offer.discount || {})
        );
        if (seen.has(key)) return;
        seen.add(key);
        merged.push(offer);
      });
    return merged;
  }

  function getNfecSalePrice(productId, catalogPrice) {
    if (!(window.nfec && nfec.manager && nfec.manager.product && typeof nfec.manager.product.FindByID === 'function')) {
      return null;
    }

    const product = nfec.manager.product.FindByID(Number(productId));
    if (!product || !product.variants) return null;

    for (let i = 0; i < product.variants.length; i++) {
      const variant = product.variants[i];
      const base =
        typeof variant.b_price === 'function'
          ? Math.abs(variant.b_price(1))
          : Math.abs(Number(variant.price) || 0);
      if (!Number.isFinite(base) || base <= 0) continue;
      if (Math.abs(base - catalogPrice) > 0.02) continue;

      if (typeof variant.display_price !== 'function') continue;
      const hasDiscountable =
        typeof variant.getDiscountable === 'function' ? variant.getDiscountable() : variant.discountable;
      if (!hasDiscountable) continue;

      const salePrice = Number(variant.display_price(1));
      if (Number.isFinite(salePrice) && salePrice > 0 && salePrice < catalogPrice - 0.001) {
        return salePrice;
      }
    }

    return null;
  }

  function getCatalogPriceDollars(productId) {
    if (window.nfec && nfec.manager && nfec.manager.product && typeof nfec.manager.product.FindByID === 'function') {
      const product = nfec.manager.product.FindByID(Number(productId));
      if (product) {
        const variant = product.variants && product.variants[0];
        if (variant) {
          const price =
            typeof variant.b_price === 'function'
              ? Math.abs(variant.b_price(1))
              : Math.abs(Number(variant.price) || 0);
          if (Number.isFinite(price) && price > 0) return price;
        }
      }
    }
    return null;
  }

  function getSellyProductPrice(productId, catalogPrice) {
    const nfecPrice = getNfecSalePrice(productId, catalogPrice);
    if (nfecPrice != null) return nfecPrice;

    let best = catalogPrice;
    collectAllOffers().forEach(function (offer) {
      if (!productInOfferGroups(offer, productId)) return;
      const discount = getDiscountForProduct(offer, productId);
      if (!discount) return;
      const price = calcPriceFromDiscount(catalogPrice, discount);
      if (Number.isFinite(price) && price < best) best = price;
    });
    return best;
  }

  function findConfiguredBundleOffer(mainIds, companionIdSets) {
    const expectedSets = [mainIds].concat(companionIdSets);
    let best = null;
    let bestExtra = Infinity;

    collectAllOffers().forEach(function (offer) {
      if (!offer.product_groups || offer.product_groups.length < 1) return;
      for (let i = 0; i < expectedSets.length; i++) {
        if (!productInOfferGroups(offer, expectedSets[i])) return;
      }
      const extra = getOfferProductIds(offer).length - expectedSets.length;
      if (extra < 0) return;
      if (!best || extra < bestExtra) {
        bestExtra = extra;
        best = offer;
      }
    });
    return best;
  }

  function parseIdList(raw) {
    if (!raw || !String(raw).trim()) return [];
    return String(raw)
      .split(',')
      .map(function (id) {
        return Number(String(id).trim());
      })
      .filter(function (id) {
        return Number.isFinite(id) && id > 0;
      });
  }

  function parseBundleIds(priceEl) {
    return parseIdList(priceEl.getAttribute('data-bundle-product-ids'));
  }

  function parseBundleVariantIds(priceEl) {
    return parseIdList(priceEl.getAttribute('data-bundle-variant-ids'));
  }

  function parseBundleItemPrices(priceEl) {
    const raw = priceEl.getAttribute('data-bundle-item-prices') || '';
    const map = {};
    if (!raw.trim()) return map;
    raw.split(',').forEach(function (pair) {
      const parts = pair.split(':');
      const id = Number(parts[0]);
      const cents = Number(parts[1]);
      if (Number.isFinite(id) && Number.isFinite(cents) && cents > 0) {
        map[id] = cents / 100;
      }
    });
    return map;
  }

  function getBundlePriceFromItems(opts) {
    const mainProductId = opts.mainProductId;
    const mainVariantId = opts.mainVariantId;
    const mainCatalogPrice = opts.mainCatalogPrice;
    const companionIds = opts.companionIds || [];
    const companionVariantIds = opts.companionVariantIds || [];
    const bundleCatalogTotalCents = opts.bundleCatalogTotalCents;
    const companionPrices = opts.companionPrices || {};

    const compareTotal = Number(bundleCatalogTotalCents) / 100;
    if (!Number.isFinite(compareTotal) || compareTotal <= 0) return null;

    const mainIds = [Number(mainProductId)];
    if (Number.isFinite(mainVariantId) && mainVariantId > 0) mainIds.push(Number(mainVariantId));

    const items = [{ ids: mainIds, catalog: mainCatalogPrice }];
    const companionIdSets = [];
    let missing = false;

    companionIds.forEach(function (id, index) {
      let catalog = companionPrices[id];
      if (catalog == null) catalog = companionPrices[String(id)];
      if (catalog == null) catalog = getCatalogPriceDollars(id);
      if (!Number.isFinite(catalog) || catalog <= 0) {
        missing = true;
        return;
      }
      const ids = [Number(id)];
      const variantId = Number(companionVariantIds[index]);
      if (Number.isFinite(variantId) && variantId > 0) ids.push(variantId);
      companionIdSets.push(ids);
      items.push({ ids: ids, catalog: catalog });
    });

    if (missing || items.length < 1 + companionIds.length) return null;

    // Automatic: same rule as PDP Total — one matching FBT/Bundle offer, per-group discounts.
    // Match by product ID and/or variant ID (Selly groups may store either).
    const matchingOffer = findConfiguredBundleOffer(mainIds, companionIdSets);
    if (!matchingOffer) return null;

    let saleTotal = 0;
    let hasDiscount = false;
    items.forEach(function (item) {
      const discount = getDiscountForProduct(matchingOffer, item.ids);
      const selly = discount ? calcPriceFromDiscount(item.catalog, discount) : item.catalog;
      saleTotal += selly;
      if (selly < item.catalog - 0.001) hasDiscount = true;
    });

    if (!hasDiscount || saleTotal >= compareTotal - 0.001) return null;
    return { salePrice: saleTotal, comparePrice: compareTotal };
  }

  function findSaleTag(priceEl) {
    if (!priceEl) return null;
    const root = priceEl.closest('[data-selly-price-root]') || priceEl.parentElement;
    if (!root) return null;
    return (
      root.querySelector('[data-selly-sale-tag]') ||
      root.querySelector('.a14-sale-tag') ||
      root.querySelector('.b24-sale-tag') ||
      root.querySelector('.selly-price__sale-tag')
    );
  }

  function updateSalePercent(priceEl, currentPrice, comparePrice) {
    if (!comparePrice || currentPrice >= comparePrice) return;
    const percent = Math.round(((comparePrice - currentPrice) / comparePrice) * 100);
    if (percent <= 0) return;

    const tag = findSaleTag(priceEl);
    if (!tag) return;
    const label =
      tag.querySelector('[data-selly-sale-percent]') ||
      tag.querySelector('.a14-sale-tag-text strong') ||
      tag.querySelector('.b24-sale-tag-percent');
    if (!label) return;

    const existing = (label.textContent || '').trim();
    if (existing && existing.indexOf('%') === -1 && /[a-zA-Z$]/.test(existing)) return;

    label.textContent = percent + '%';
    tag.hidden = false;
    tag.removeAttribute('hidden');
  }

  function applyPrice(priceEl, salePrice, comparePrice) {
    const currentEl =
      priceEl.querySelector('.selly-price__current, .current-price') ||
      priceEl.querySelector('.price-item--sale');
    const compareEl = priceEl.querySelector('.selly-price__compare, del');
    if (!currentEl) return;

    currentEl.innerHTML = formatMoney(salePrice);
    currentEl.setAttribute('data-calc-price', String(Math.round(salePrice * 100)));
    priceEl.setAttribute('data-price', String(Math.round(salePrice * 100)));

    if (compareEl && comparePrice && comparePrice > salePrice) {
      compareEl.innerHTML = formatMoney(comparePrice);
      compareEl.setAttribute('data-calc-price', String(Math.round(comparePrice * 100)));
      compareEl.hidden = false;
      compareEl.removeAttribute('hidden');
      priceEl.setAttribute('data-compare-price', String(Math.round(comparePrice * 100)));
    }

    updateSalePercent(priceEl, salePrice, comparePrice);
    priceEl.setAttribute('data-selly-synced', '1');
    priceEl.dispatchEvent(new CustomEvent('selly-price:updated', { bubbles: true }));
  }

  function offersAreReady() {
    if (rawSaleOffers.length || rawBundleOffers.length) return true;
    if (!(window.sl9 && sl9.manager && sl9.manager.offer)) return false;
    return collectAllOffers().length > 0;
  }

  function syncSellyPrices(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-selly-price][data-product-id]').forEach(function (priceEl) {
      if (priceEl.getAttribute('data-selly-synced') === '1') return;
      if (priceEl.getAttribute('data-manual-price') === 'true') return;
      if (!offersAreReady()) return;

      const productId = priceEl.getAttribute('data-product-id');
      const catalogPriceCents = Number(
        priceEl.getAttribute('data-catalog-price') || priceEl.getAttribute('data-price')
      );
      const catalogPrice = catalogPriceCents / 100;
      if (!Number.isFinite(catalogPrice) || catalogPrice <= 0) return;

      const companionIds = parseBundleIds(priceEl);
      const bundleCatalogTotal = Number(priceEl.getAttribute('data-bundle-catalog-total'));
      const hasBundleConfig =
        companionIds.length > 0 &&
        Number.isFinite(bundleCatalogTotal) &&
        bundleCatalogTotal > 0;

      if (hasBundleConfig) {
        const companionPrices = parseBundleItemPrices(priceEl);
        const companionVariantIds = parseBundleVariantIds(priceEl);
        const mainVariantId = Number(priceEl.getAttribute('data-main-variant-id') || priceEl.getAttribute('data-variant-id'));
        const bundle = getBundlePriceFromItems({
          mainProductId: productId,
          mainVariantId: mainVariantId,
          mainCatalogPrice: catalogPrice,
          companionIds: companionIds,
          companionVariantIds: companionVariantIds,
          bundleCatalogTotalCents: bundleCatalogTotal,
          companionPrices: companionPrices,
        });
        if (bundle) {
          applyPrice(priceEl, bundle.salePrice, bundle.comparePrice);
        }
        return;
      }

      const sellyPrice = getSellyProductPrice(productId, catalogPrice);
      if (!Number.isFinite(sellyPrice) || sellyPrice <= 0) return;
      if (sellyPrice >= catalogPrice - 0.001) return;

      applyPrice(priceEl, sellyPrice, catalogPrice);
    });
  }

  function onAppData(eventName, data) {
    normalizeRawOffers(data);
    document.querySelectorAll('[data-selly-price][data-selly-synced="1"]').forEach(function (el) {
      el.removeAttribute('data-selly-synced');
    });
    syncSellyPrices();
  }

  function start() {
    let tries = 0;
    const maxTries = 200;
    let boundDataApp = false;

    const tick = function () {
      if (!boundDataApp && window.tdfEventHub && typeof tdfEventHub.ListenToEvent === 'function') {
        tdfEventHub.ListenToEvent('data_app2', onAppData, true);
        boundDataApp = true;
      }
      syncSellyPrices();
      tries += 1;
      if (tries >= maxTries) clearInterval(timer);
    };

    function bindNfecHub() {
      if (window.nfec && nfec.event_hub && typeof nfec.event_hub.ListenTo === 'function') {
        nfec.event_hub.ListenTo('promo_updated', tick, true, true);
        return true;
      }
      return false;
    }

    if (!bindNfecHub()) {
      const hubTimer = setInterval(function () {
        if (bindNfecHub()) clearInterval(hubTimer);
      }, 300);
      setTimeout(function () {
        clearInterval(hubTimer);
      }, 30000);
    }

    tick();
    const timer = setInterval(tick, 200);
  }

  window.SellyPrice = {
    __initialized: true,
    sync: syncSellyPrices,
    setOffers: function (data) {
      normalizeRawOffers(data);
      document.querySelectorAll('[data-selly-price][data-selly-synced="1"]').forEach(function (el) {
        el.removeAttribute('data-selly-synced');
      });
      syncSellyPrices();
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
